import Attivita from './Attivita';
import {minutesToHuman} from '../Helpers'

class ReddittivitaCommesse extends Attivita {

    createPdf(items){

        const columns = [
            {title: "IdCommessa", dataKey: "id"},
            {title: "Priorita", dataKey: "priorita"},
            {title: "Colore", dataKey: "colore"},
            {title: "Commessa", dataKey: "com"},
            {title: "Entrate", dataKey: "entrate"},
            {title: "Uscite", dataKey: "uscite"},
            {title: "Num. Attività", dataKey: "numatt"},
            {title: "Durata Totale\n(h:m)", dataKey: "duratahms"},
            {title: "Reddittività", dataKey: "red"},
        ];
        let rows = [];
        let entrateTot = 0;
        let usciteTot = 0;
        let numAttivitaTot = 0;
        let durataPesataTot = 0;

        items.map((item) => {
            let it = {
                id: item.idCommessa,
                priorita: item.prioritaCommessa,
                colore: item.coloreCommessa,
                com: item.nomeCommessa,
                entrate: this.formatCurrency(item.sommaTotaleEntrate),
                uscite: this.formatCurrency(item.sommaTotaleUscite),
                numatt: item.numeroAttivita,
                duratahms: minutesToHuman(item.sommaDurataPesata),
                red: this.formatDecimal(item.reddittivita, 1),
            };
            rows.push(it);
            numAttivitaTot += item.numeroAttivita;
            durataPesataTot += item.sommaDurataPesata;
            entrateTot += item.sommaTotaleEntrate;
            usciteTot += item.sommaTotaleUscite;
            return 0;
        });
        rows.push({
            id: '',
            priorita: '',
            colore: '',
            com: '',
            entrate: this.formatCurrency(entrateTot),
            uscite: this.formatCurrency(usciteTot),
            numatt: numAttivitaTot,
            duratahms: minutesToHuman(durataPesataTot),
            red: ''
        })

        super.createPdf(columns, rows,
            {
                createdCell: this.doDrawCell,
                drawRow: this.doDrawRow,
                columnStyles: {
                    com: {halign: 'left', columnWidth: 'auto', overflow:'hidden'},
                    numatt: {halign: 'center'},
                    priorita: {halign: 'center'},
                    duratahms: {halign: 'center'},
                    entrate: {halign: 'right'},
                    uscite: {halign: 'right'},
                    red: {halign: 'right'},
                },
                headerStyles: {
                    valign: 'middle',
                    halign: 'center',
                    //fillColor: [0x56, 0x9e, 0xdd],
                    //fillColor: [0xFF, 0xFF, 0xFF],
                    fillColor: false,
                    textColor: [0,0,0],
                    ses:{halign: 'center'},
                    duratamin:{halign: 'center'},
                    duratahms:{halign: 'center'},
                },
            });
    }


}

export default ReddittivitaCommesse;


/** WEBPACK FOOTER **
 ** ./src/pdf/ReddittivitaCommesse.js
 **/